import { defineMessages } from 'react-intl';

export default defineMessages({
    itemType: {
        id: 'ml.quoteandbind.schedproperty.itemType',
        defaultMessage: 'Item Type'
    },
    perItem: {
        id: 'ml.quoteandbind.schedproperty.perItem',
        defaultMessage: 'Per Item'
    },
    totalLimit: {
        id: 'ml.quoteandbind.schedproperty.totalLimit',
        defaultMessage: 'Total Limit'
    },
    action: {
        id: 'ml.quoteandbind.schedproperty.action',
        defaultMessage: 'Action'
    },
    add: {
        id: 'ml.quoteandbind.schedproperty.add',
        defaultMessage: 'Add'
    },
    addVpp: {
        id: 'ml.quoteandbind.schedproperty.addVpp',
        defaultMessage: 'ADD VALUABLE PERSONAL PROPERTY'
    },
    addSpp: {
        id: 'ml.quoteandbind.schedproperty.addSpp',
        defaultMessage: 'ADD SCHEDULED PERSONAL PROPERTY'
    },
    edit: {
        id: 'ml.quoteandbind.schedproperty.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.schedproperty.remove',
        defaultMessage: 'Remove'
    },
    loadMore: {
        id: 'ml.quoteandbind.schedproperty.loadMore',
        defaultMessage: 'Load More'
    },
    collapse: {
        id: 'ml.quoteandbind.schedproperty.collapse',
        defaultMessage: 'Collapse'
    },
    modalAddVpp: {
        id: 'ml.quoteandbind.schedproperty.modalAddVpp',
        defaultMessage: 'Add Valuable Personal Properties'
    },
    modalEditVpp: {
        id: 'ml.quoteandbind.schedproperty.modalEditVpp',
        defaultMessage: 'Edit Valuable Personal Properties'
    },
    modalAddSpp: {
        id: 'ml.quoteandbind.schedproperty.modalAddSpp',
        defaultMessage: 'Add Schedule Personal Properties'
    },
    modalEditSpp: {
        id: 'ml.quoteandbind.schedproperty.modalEditSpp',
        defaultMessage: 'Edit Schedule Personal Properties'
    },
    modalContinue: {
        id: 'ml.quoteandbind.schedproperty.modalContinue',
        defaultMessage: 'Continue'
    },
    modalCancel: {
        id: 'ml.quoteandbind.schedproperty.modalCancel',
        defaultMessage: 'Cancel'
    }
});
